import React, { useMemo } from 'react';
import OsLevelGamUprConfig from './OsLevelGamUprConfig';
import OsLevelGamUprJson from './OsLevelGamUprJson';
import constants from '../constants.json';
//mui imports====
import { Box } from '@mui/material';
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';
import GeneralTab from '../../../../../Components/GeneralTabAndTabContent';

const GamUprTabConfig = ({ keyData, platform, operatingSystem }) => {
	const {
		gamUprTabs: { GamUprConfig, GamUprJson }
	} = constants;

	const tabListAndPanels = useMemo(() => {
		if (!keyData || !platform) {
			return [];
		}
		return [
			{
				tab: <Tab label="Gam Upr Config" value={GamUprConfig} />,
				tabPanel: (
					<TabPanel value={GamUprConfig}>
						<OsLevelGamUprConfig
							keyData={keyData}
							platform={platform}
							operatingSystem={operatingSystem}
						/>
					</TabPanel>
				)
			},
			{
				tab: <Tab label="Gam Upr Json" value={GamUprJson} />,
				tabPanel: (
					<TabPanel value={GamUprJson}>
						<OsLevelGamUprJson
							keyData={keyData}
							platform={platform}
							operatingSystem={operatingSystem}
						/>
					</TabPanel>
				)
			}
		];
	}, [keyData, platform, operatingSystem]);

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center'
			}}
		>
			<GeneralTab
				tabListAndPanels={tabListAndPanels}
				tabListStyles={{ width: 'fit-content', marginLeft: '3rem' }}
			/>
		</Box>
	);
};

export default GamUprTabConfig;
